<div
  class="overflow-auto scrollable-wrapper"
  #scrollableWrapper
  [class.flex-grow-1]="isGrowing"
  [class.h-0]="isGrowing"
>
  <ng-content />
</div>
